import { Link } from 'react-router-dom'
import './Home.css'

export default function Home() {
    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1 className="hero-title fade-in">
                            Premium Products for
                            <span className="gradient-text"> Modern Business</span>
                        </h1>
                        <p className="hero-subtitle fade-in">
                            Discover our curated collection of high-quality products designed
                            to elevate your corporate environment.
                        </p>
                        <div className="hero-actions fade-in">
                            <Link to="/products" className="btn btn-primary btn-lg">
                                Browse Products
                            </Link>
                            <Link to="/about" className="btn btn-secondary btn-lg">
                                Learn More
                            </Link>
                        </div>
                    </div>
                    <div className="hero-visual">
                        <div className="hero-shape shape-1"></div>
                        <div className="hero-shape shape-2"></div>
                        <div className="hero-shape shape-3"></div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features section">
                <div className="container">
                    <h2 className="section-title text-center">Why Choose SecondWorld</h2>
                    <div className="features-grid">
                        <div className="feature-card card">
                            <div className="feature-icon">🚀</div>
                            <h3>Fast Delivery</h3>
                            <p>Quick and reliable shipping to your doorstep within 2-5 business days.</p>
                        </div>
                        <div className="feature-card card">
                            <div className="feature-icon">✨</div>
                            <h3>Premium Quality</h3>
                            <p>Carefully selected products that meet the highest quality standards.</p>
                        </div>
                        <div className="feature-card card">
                            <div className="feature-icon">🛡️</div>
                            <h3>Secure Payments</h3>
                            <p>Your transactions are protected with industry-leading security.</p>
                        </div>
                        <div className="feature-card card">
                            <div className="feature-icon">💬</div>
                            <h3>24/7 Support</h3>
                            <p>Our dedicated team is always ready to assist you anytime.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta section">
                <div className="container">
                    <div className="cta-card">
                        <h2>Ready to Get Started?</h2>
                        <p>Join thousands of satisfied customers and experience the SecondWorld difference.</p>
                        <Link to="/products" className="btn btn-primary btn-lg">
                            Shop Now
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    )
}
